import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { getVoteNum, vote } from '@ifeng-fe/container_content/common/client/services/api';
import { requestTongji } from '../../../../../../services/api';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Vote extends React.PureComponent {
    static propTypes = {
        url: PropTypes.string,
        interact: PropTypes.object,
    };

    state = {
        isVoted: false,
        voteNum: 0,
    };

    async componentDidMount() {
        try {
            const { url } = this.props;

            const data = await getVoteNum(`${url}ding`);

            this.setState({ voteNum: data.browse[`${url}ding`] });
        } catch (e) {
            console.error(e);
        }
    }

    vote = async () => {
        try {
            const { isVoted } = this.state;

            if (isVoted) {
                return;
            }

            const { url } = this.props;

            const data = await vote(`${url}ding`);

            this.setState({
                isVoted: !isVoted,
                voteNum: data,
            });

            requestTongji('pic', 'laud');
        } catch (e) {
            console.error(e);
        }
    };

    /**
     * 渲染网页布局
     */

    render() {
        const { isVoted, voteNum } = this.state;
        const { interact } = this.props;
        const { isCloseLike, isOpenCandle, isOpenpray } = interact;

        return (
            <>
                {!isCloseLike &&
                    !isOpenCandle &&
                    !isOpenpray && (
                        <li className={isVoted ? styles.change : styles.good} onClick={this.vote}>
                            {voteNum}
                        </li>
                    )}
                {isCloseLike &&
                    isOpenCandle && (
                        <li className={isVoted ? styles.change1 : styles.good1} onClick={this.vote}>
                            {voteNum}
                        </li>
                    )}
                {isCloseLike &&
                    isOpenpray && (
                        <li className={isVoted ? styles.change2 : styles.good2} onClick={this.vote}>
                            {voteNum}
                        </li>
                    )}
            </>
        );
    }
}

export default errorBoundary(Vote);
